/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Tagline_PlaceholderInputs */

const en_directory_submit_tagline_placeholder = /** @type {(inputs: Directory_Submit_Tagline_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One sentence describing what the tool does.`)
};

const zh_directory_submit_tagline_placeholder = /** @type {(inputs: Directory_Submit_Tagline_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用一句话描述这个工具是做什么的。`)
};

/**
* | output |
* | --- |
* | "One sentence describing what the tool does." |
*
* @param {Directory_Submit_Tagline_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_tagline_placeholder = /** @type {((inputs?: Directory_Submit_Tagline_PlaceholderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Tagline_PlaceholderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_tagline_placeholder(inputs)
	return zh_directory_submit_tagline_placeholder(inputs)
});
export { directory_submit_tagline_placeholder as "directory.submit.tagline_placeholder" }